import axios from 'axios';

// CRA embute a variável no bundle em BUILD time — em produção ela chega pelo
// --build-arg do Dockerfile (ver deploy/build-and-push.sh). Localmente, pelo .env.
// O fallback só vale pra `npm start` sem .env.
export const baseURL = process.env.REACT_APP_API_URL || "http://localhost:3000/";
const api = axios.create({
    baseURL: baseURL
});

// Interceptador para adicionar o token do usuário ao cabeçalho da requisição
api.interceptors.request.use(
  config => {
    let usuario = sessionStorage.getItem('usuario');
    if(usuario){
      usuario = JSON.parse(usuario);
    }
    config.headers.Authorization = usuario ? `Bearer ${usuario.token}` : ``;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
  
);

export default api;